export type reasonsKey = 'impersonation' | 'scam' | 'spam' | 'other'

export interface Reason {
  id: string
  translationKey: string
  apiKey: reasonsKey
}

export const reasonsList: Reason[] = [
  {
    id: '0',
    translationKey: 'impersonation',
    apiKey: 'impersonation',
  },
  {
    id: '1',
    translationKey: 'scam',
    apiKey: 'scam',
  },
  {
    id: '2',
    translationKey: 'spamAccount',
    apiKey: 'spam',
  },
  {
    id: '3',
    translationKey: 'other',
    apiKey: 'other',
  },
]
